/*
 * @Author: TJ.
 * @Date: 2022-03-24 13:37:38
 * @LastEditors: inHeaven98 10899060+inheaven98@user.noreply.gitee.com
 * @LastEditTime: 2024-05-17 17:24:26
 * @Description: 品牌相关接口
 * @FilePath: \cei-saas-platform\src\api\brand.js
 */
import request from '@/utils/request'

// 获取品牌列表
export function getBrandList(data) {
  return request({
    url: '/Brand/getBrandList',
    method: 'post',
    data
  })
}
// 添加品牌
export function addBrand(data) {
  return request({
    url: '/Brand/addBrand',
    method: 'post',
    data
  })
}
// 查询品牌信息
export function getBrandData(data) {
  return request({
    url: '/Brand/getBrandData',
    method: 'post',
    data
  })
}
// 编辑品牌信息
export function editBrand(data) {
  return request({
    url: '/Brand/editBrand',
    method: 'post',
    data
  })
}
// 删除品牌信息
export function deleteBrand(data) {
  return request({
    url: 'Brand/deleteBrand',
    method: 'post',
    data
  })
}

// 获取状态
export function getBrandStatus(data) {
	return request({
		url: '/Brand/getBrandStatus',
		method: 'post',
		data
	})
}

// 获取直营店信息
export function getShopData(data) {
	return request({
		url: '/Brand/getShopData',
		method: 'post',
		data
	})
}

// 获取当前品牌列表
export function getBrandLists(data) {
	return request({
		url: '/Brand/getBrandLists',
		method: 'post',
		data
	})
}

// 切换品牌
export function switchBrand(data) {
	return request({
		url: '/Brand/switchBrand',
		method: 'post',
		data
	})
}

// 获取品牌列表[新] 品牌列表页面调用
export function getBrandStatusList(data) {
	return request({
		url: '/Brand/getBrandStatusList',
		method: 'post',
		data
	})
}

